/**
 * @author      Dario Casertano <dario@casertano.name>
 * @copyright   Copyright (c) 2021 Casertano Dario – All rights reserved.
 * @license     Creative Commons Attribution-NonCommercial-NoDerivatives 4.0 International.
 */

import Component from "vue-class-component";

Component.registerHooks([
    "beforeRouteEnter",
    "beforeRouteUpdate",
    "beforeRouteLeave",
]);
